/**
 * When this tab last heard from esback, and whether esback has since refused it as a stranger.
 *
 * <p>esFetch reports every answer here. EsSessionExpiry reads it to time the reader's return to
 * the login (T9): the session's idle clock restarts on each request, so the last answer plus
 * the idle limit is the earliest it can have run out. A 401 is reported apart, as a sign it may
 * already have; the watcher asks authUser before believing it, because a wrong password on a
 * confirm also answers 401.
 */

let touched = Date.now();
let leaving = false;
const refusals = new Set();

export function esSessionAnswered( pResponse ) {
    // A gateway status is the proxy answering for an esback it could not reach (EsServerStatus).
    if ( [ 502, 503, 504 ].includes( pResponse?.status ) ) return;
    touched = Date.now();
    if ( pResponse?.status === 401 ) refusals.forEach( ( aListener ) => aListener() );
}

export function esSessionTouchedAt() {
    return touched;
}

export function esSessionOnRefused( pListener ) {
    refusals.add( pListener );
    return () => refusals.delete( pListener );
}

// A logout or an account delete is leaving on purpose, and its own requests may answer
// signed out on the way: none of that is a session timing out.
export function esSessionLeaving() {
    leaving = true;
}

export function esSessionIsLeaving() {
    return leaving;
}
